import { useEffect, useState } from 'react';

import fetch from 'unfetch';
import login from './Login';
import reAuthorize from './reAuthorize';
const verifyUser = async (type) => {
	const url = `/api/verifyuser`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: localStorage.getItem('auth'),
		},
	});

	if (res.ok) {
		console.log('Valid!');
		return { status: 'success' };
	} else {
		let errorData = await res.json();
		console.log(errorData);
		if (errorData?.code === 1) {
			let d = await reAuthorize();
			if (d?.status !== 'error') {
				let r = await verifyUser();
				return r;
			} else {
				return { status: 'error' };
			}
		}
		return { status: 'error' };
	}
};
export default verifyUser;
